import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Routes, Route, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import District from '../pages/district';
import AccessDenied from '../pages/account/accessdenied';
//import Main from '../pages/main/main.jsx';

import { accountRoutes } from './Accountrouter';
import { appRoutes } from './Approuter';
import { adminRoutes } from './Adminrouter';

import PropTypes from 'prop-types';
import { getDistrictByPath } from '../api/districtapi';
//import { bindActionCreators } from "@reduxjs/toolkit";
import { demoUserLogin } from '../store/auth/actions';

function Element({ element, layout, secure, adminPage }) {
    const { isAuthenticated, isAdmin } = useSelector((state) => state.auth);
    const [mounted, setMounted] = useState(false);

    console.log('state.auth', adminPage, secure, isAuthenticated, isAdmin);
    const Component = element;
    const Layout = layout;
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if(mounted == false){
            setMounted(true);
        }else{
            checkAuthStatus();
        }
    }, [mounted, isAuthenticated, secure, adminPage, navigate, location, dispatch]);

    
    const checkAuthStatus = async () => {
        const org = searchParams.get('org');
        if (adminPage && !isAdmin) { 
            navigate('/account/login');
            return;
        }
        if (!isAuthenticated && !isAdmin) {
            secure = true;
        }
        if (secure && !isAuthenticated) {         
            const paths = window.location.pathname
                .split('/')
                .filter(segment => segment.trim() !== '');
            
            console.log("org  ", org);
            if (org || paths.length > 0) {
                if (paths[0] !== 'account') {
                    const response = await getDistrictByPath(org ? org : paths[0]);
                    if (response.status === 200 && response.data.success) {
                        const district = response.data.data;
                        if (district.isDemo) {
                            localStorage.setItem('district', JSON.stringify(district));
                            localStorage.setItem('districtId', district.id);

                            if (localStorage.getItem('demoUserId') === 'undefined') {
                                localStorage.setItem('demoUserId', '');
                            }

                            const result = await dispatch(demoUserLogin({ districtId: district.id })).unwrap();
                            if (!result.data.success) {
                                navigate('/account/login', { state: { from: location } });
                            }
                        } else {
                            navigate('/account/login', { state: { from: location } });
                        }
                    } else {
                        navigate('/account/login', { state: { from: location } });
                    }
                }
            } else {
                navigate('/?org=demo', { state: { from: location } });
            }
        }
        setLoading(false);
    };

    if (loading) {
        return null;
    }

    if (adminPage && !isAdmin) return null;
    if (secure && !isAuthenticated) return null;
    //make sure demo district URLs contain ?org=
    var districtJson = localStorage.getItem('district');
    if (typeof districtJson == 'string') {
        var district = JSON.parse(districtJson);
        if (district.isDemo == true) {
            if (window.location.href.indexOf('?org=' + district.path) < 0) { 
                history.replaceState(null, null, window.location.pathname + '?org=' + district.path);
            }
        }
    }

    if (Layout) {
        return (
            <Layout>
                <Component />
            </Layout>
        );
    } else {
        return (
            <Component />
        );
    }

}

Element.propTypes = {
    element: PropTypes.any,
    layout: PropTypes.any,
    secure: PropTypes.bool,
    adminPage: PropTypes.bool
};

Element.defaultProps = {
    secure: true,
    adminPage: false
}


export const createRoutes = (routesData) =>
    routesData.map((route) => {
        if (route.routes?.length) {
            const indexRoute = route.routes.find((r) => r.index);
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={<Element {...route} />}
                    index={route.index}
                >
                    {!!indexRoute && (
                        <Route index element={<Element {...route} />} />
                    )}
                    {createRoutes(route.routes)}
                </Route>
            );
        }
        return (
            <Route
                key={route.path}
                path={route.path}
                element={<Element {...route} />}
                index={route.index}
            />
        );
    });

export default function AppRouter() {
    return (
        <Routes>
            {createRoutes(accountRoutes)}
            {createRoutes(appRoutes)}
            {createRoutes(adminRoutes)}

            <Route
                path='access-denied'
                element={<AccessDenied />}
            />
            <Route
                path='*'
                element={<District />}
            />
        </Routes>);
}
